import { IconProps } from '@chakra-ui/react'

import { ArrowUpIcon } from '../Icons/ArrowUpIcon'

export type TrendArrowDirections = 'up' | 'down'

export type TrendArrowProps = IconProps & {
  value?: number
  direction?: TrendArrowDirections
}

/**
 * Renders an arrow who's direction and color depend on the value and direction props.
 * TODO: direction is currently hard coded to up is bad. This may need to be dynamic too.
 */
export const TrendArrow = ({ value, direction, ...props }: TrendArrowProps) => {
  if (typeof value === 'undefined' && !direction) return null

  const isUp = direction === 'up' || (typeof value === 'number' && value > 0)

  return (
    <ArrowUpIcon
      boxSize="14px"
      transform={isUp ? 'rotate(0deg)' : 'rotate(180deg)'}
      color={isUp ? 'presets.pink.70' : 'presets.turquoise.30'}
      {...props}
    />
  )
}
